export enum ValidationResultErrorMessage {
    NoError,
    InvalidAccount,
    InvalidOrderTemplate,
    InvalidQuotation,
    InvalidContract,
    InvalidSampleTemplate,
    InvalidAdditionalFields,
    InvalidReportGroupingRule,
    InvalidPriorityLevel,
    InvalidCustomerOrderReference,
    CustomerOrderReferenceMissing,
    InvalidOrderAdditionalFields,
    InvalidRecipients,
    MandatoryAdditionalFields,
    MandatoryOrderAdditionalFields,
    AllSamplesAnalysisMissing,
    ServingUnitMissing,
    InvalidOrderSampleReference,
    InvalidProductMatrix,
    SomeOrAllInvoiceableItemsAreRemoved,
    LabelClaimSpecMissing,
}
